import {
  ACCOUNT_DISQUALIFY_DISPOSITIONS,
  CONTACT_DISQUALIFY_DISPOSITIONS,
  DISQUALIFY_DISPOSITION_LABELS,
  DISQUALIFY_DISPOSITIONS,
} from "shared/lib/constants/dispositions";
import { DisqualifyDispositionI } from "shared/lib/interfaces/dispositions";

const createDropdownOption = (value: string) => ({
  label:
    DISQUALIFY_DISPOSITION_LABELS[
      value as keyof typeof DISQUALIFY_DISPOSITIONS
    ],
  value,
});

export const ACCOUNT_DQ_DISPOSITIONS = Object.values(
  ACCOUNT_DISQUALIFY_DISPOSITIONS
);

export const CONTACT_DQ_DISPOSITIONS = Object.values(
  CONTACT_DISQUALIFY_DISPOSITIONS
);

export const ACCOUNT_DQ_DISPOSITIONS_OPTIONS =
  ACCOUNT_DQ_DISPOSITIONS.map(createDropdownOption);

export const CONTACT_DQ_DISPOSITIONS_OPTIONS =
  CONTACT_DQ_DISPOSITIONS.map(createDropdownOption);

/**
 * The reason dropdown keeps its value when the rep switches between the
 * account and a lead, so it can hold a reason the other side doesn't offer.
 * That falls back to the first reason on the selected side, which is what gets
 * submitted and what decides whether a meeting is cancelled.
 */
export const resolveDisqualifyDisposition = (
  isAccountSelected: boolean,
  disposition: DisqualifyDispositionI
): DisqualifyDispositionI => {
  const allowed = isAccountSelected
    ? ACCOUNT_DQ_DISPOSITIONS
    : CONTACT_DQ_DISPOSITIONS;

  return allowed.includes(disposition) ? disposition : allowed[0];
};
